import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const Fade = ({ show, children }) => {
  const [shouldRender, setRender] = useState(show)

  useEffect(() => {
    if (show) setRender(true)
  }, [show])

  const onAnimationEnd = () => {
    if (!show) setRender(false)
  }

  return (
    shouldRender && (
      <div style={{ animation: `${show ? 'responseFadeIn' : 'responseFadeOut'} .5s` }} onAnimationEnd={onAnimationEnd}>
        {children}
      </div>
    )
  )
}

Fade.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node
}

export default Fade
